import React, { useState } from "react";

const Principles = () => {
  const [expanded, setExpanded] = useState({});

  const toggleExpand = (index) => {
    setExpanded((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const founderPrinciples = [
    {
      title: "Aspiration",
      description:
        "Aspiration is the relentless pursuit of improvement for all. By thinking big and pushing boundaries, we challenge the idea of impossibility and make it happen by continuously innovating and thinking differently.",
    },
    {
      title: "Humility",
      description:
        "Humility is crucial for our organization’s growth. We believe it’s essential to foster transparency, respect failures, and prioritize learning from them. In challenging times, humility is key.",
    },
    {
      title: "Hunger",
      description:
        "Success goes beyond aspirations; it demands enthusiasm and action. When people within an organization are truly hungry for success, ready to roll up their sleeves to tackle challenges head-on and go the extra mile, we’re confident that organization will not just survive, but thrive.",
    },
  ];
  const coreValues = [
    {
      title: "Customer Focus",
      description:
        "We treat your business as if it were our own, actively brainstorming ideas and providing solutions to achieve your goals and make the impossible possible.",
    },
    {
      title: "Collaboration",
      description:
        "Building long-term relationships with our customers is at the heart of what we do, and we invest in every connection we make. While it may not be the initial reason they choose us, it’s the reason they stay.",
    },
    {
      title: "Integrity",
      description:
        "As a company and individuals, we’re dedicated to championing what’s right for our people, customers, and communities. We aim to be a positive force for good beyond just business.",
    },
  ];

  return (
    <div style={styles.pageBackground}>
      <div style={styles.container}>
        <h2 style={styles.heading}><span style={{ color: "black" }}>What sets us apart</span></h2>
        <p style={styles.description}>
          Our founder’s principles and core values drive our culture. They are deeply rooted in
          everything we do and shine brightest in our behaviors, attitudes, and values.
        </p>

        {/* Two-Column Layout */}
        <div style={styles.row}>
          {/* Founder's Principles */}
          <div style={styles.column}>
            <h3 style={styles.subHeading}>Our founder’s principles</h3>
            {founderPrinciples.map((item, index) => (
              <div key={index} style={styles.box} onClick={() => toggleExpand(index)}>
                <div style={styles.boxHeader}>
                  <h4 style={styles.boxTitle}>{item.title}</h4>
                  <span style={styles.plusIcon}>{expanded[index] ? "−" : "+"}</span>
                </div>
                {expanded[index] && <p style={styles.boxContent}>{item.description}</p>}
              </div>
            ))}
          </div>

          {/* Core Values */}
          <div style={styles.column}>
            <h3 style={styles.subHeading}>Our core values</h3>
            {coreValues.map((item, index) => (
              <div key={index} style={styles.box} onClick={() => toggleExpand(`core-${index}`)}>
                <div style={styles.boxHeader}>
                  <h4 style={styles.boxTitle}>{item.title}</h4>
                  <span style={styles.plusIcon}>{expanded[`core-${index}`] ? "−" : "+"}</span>
                </div>
                {expanded[`core-${index}`] && <p style={styles.boxContent}>{item.description}</p>}
              </div>
            ))}
          </div>
        </div>

        <p style={styles.footerText}>
          Think big, embrace learning, empower decision-making. These principles drive our success.
        </p>
      </div>
    </div>
  );
};

// Updated Styles
const styles = {
  pageBackground: {
    backgroundColor:"#C4D8E2", // Full page background in black
    padding: "50px 0", // Spacing around the container
  },
  container: {
    backgroundColor:"#C4D8E2", // Outer container in black
    color: "white",
    padding: "80px 60px",
    textAlign: "left",
    maxWidth: "1200px",
    margin: "0 auto",
    borderRadius: "10px",
  },
  heading: {
    fontSize: "42px",
    fontWeight: "bold",
    color: "#FFC107",
    marginBottom: "20px",
  },
  description: {
    fontSize: "18px",
    maxWidth: "900px",
    marginBottom: "40px",
    color:"black",
  },
  row: {
    display: "flex",
    justifyContent: "space-between",
    gap: "30px",
    flexWrap: "wrap",
  },
  column: {
    flex: "1",
    minWidth: "300px",
  },
  subHeading: {
    fontSize: "24px",
    marginBottom: "20px",
    color:"black"
  },
  box: {
    //backgroundColor: "#6A7FB5", // Dark grey box
    background: "radial-gradient(circle, #1F6788,#161623)",
    padding: "20px",
    borderRadius: "8px",
    marginBottom: "20px",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
    boxShadow: `
    0px 12px 25px rgba(0, 0, 0, 0.6),  
    inset 0px 10px 20px rgba(255, 255, 255, 0.15),
    inset 0px -10px 30px rgba(0, 0, 0, 0.7),
    inset 10px 0px 20px rgba(0, 0, 0, 0.5), 
    inset -10px 0px 20px rgba(255, 255, 255, 0.2)
  `,
  },
  boxHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  boxTitle: {
    fontSize: "20px",
    fontWeight: "bold",
  },
  plusIcon: {
    fontSize: "24px",
    fontWeight: "bold",
    cursor: "pointer",
  },
  boxContent: {
    marginTop: "10px",
    fontSize: "16px",
  },
  footerText: {
    marginTop: "20px",
    fontSize: "16px",
    color:"black"
   
  },
};

export default Principles;